module.exports = __webpack_public_path__ + "static/media/compass.628926f5.svg";